import { useQuery, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { IglooDevices, normalizeIglooDevices, RawIglooDevices } from './normalize-igloo-devices'

type GetIglooDevicesRequest = { clientId: string }

export const getIglooDevicesQueryKey = (data: GetIglooDevicesRequest) => [
  'useGetIglooDevices',
  data,
]

const getIglooDevices = async (data: GetIglooDevicesRequest): Promise<IglooDevices> => {
  const response = await authAPI.get<RawIglooDevices>(`/igloowork/${data.clientId}/devices`)
  return normalizeIglooDevices(response.data)
}

export const useGetIglooDevices = (data: GetIglooDevicesRequest, enabled = true) =>
  useQuery({
    enabled: enabled && Boolean(data.clientId),
    queryFn: () => getIglooDevices(data),
    queryKey: getIglooDevicesQueryKey(data),
  })

export const useInvalidateIglooDevices = (clientId: string) => {
  const queryClient = useQueryClient()
  return () => queryClient.invalidateQueries({ queryKey: getIglooDevicesQueryKey({ clientId }) })
}
